import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=5056b027&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/menu.scss?vue&type=style&index=0&id=5056b027&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056b027",
  null
  
)

export default component.exports